<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" xl="3" lg="3" md="4" style="position:relative; top: -60px">
                <v-card>
                    <v-card-title>Niveles</v-card-title>
                    <v-card-text>
                        <v-select outlined v-model="selected_level" :items="levels" item-text="name" item-value="id" placeholder="Selecciona un nivel"></v-select>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" xl="9" lg="9" md="8" style="position:relative; top: -60px">
                <v-card>
                    <v-card-text>
                        <v-data-table :loading="loading" :loading-text="loading_text" :items="items" :headers="headers" :no-data-text="no_data_text">
                            <template v-slot:item.register="{ item }">
                                <v-chip v-if="item.user_id" color="success">Registrado</v-chip>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ attrs, on }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-menu</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item @click="delete_item(item)">
                                            <v-list-item-title>Eliminar registro</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    props:{
        levels: Array
    },

    data:() => ({
        selected_level:"",
        loading:false,

        //data table props
        items:[],
        headers:[
            { text:'Nombre(s)', value:'name' },
            { text:'Email', value:'email' },
            { text:'Hora de inicio', value:'start_time' },
            { text:'Registro', value:'register' },
            { text:'Fecha', value:'date' },
            { text:'Acciones', value:'actions' }
        ],
        loading_text: 'Cargando...',
        no_data_text:"Sin resultados"
    }),

    watch:{
        selected_level:function(val)
        {
            this.get_data(val)
        }
    },

    methods:{
        get_data:function(val)
        {
            this.loading = true
            axios.get('/waiting_list', { params:{ level_id:val, ajax:true } }).then(response => {
                this.items = response.data.items
                this.loading = false
            })
        },

        delete_item:function(item)
        {
            axios.post('/waiting_list/delete', { id:item.id }).then(() => {
                this.get_data(this.selected_level)
            })
        }
    }
}
</script>